import { appUtils, configs } from ".";
import { AppBase } from "./appBase";
import { mapPlaces } from "./data/mapPlaces";
import templates from "bundle-text:../templates/ts-contact.html";

class AppContact extends AppBase {
    private _inputName: NodeListOf<HTMLElement>;
    private _inputEmail: NodeListOf<HTMLElement>;
    // private _inputKVKK: NodeListOf<HTMLElement>;
    private _inputTopic: NodeListOf<HTMLElement>;
    private _inputMessage: NodeListOf<HTMLElement>;
    private _templates: { [tag: string]: string; };
    private _dotsCont: HTMLElement;
    private _dots: HTMLElement[];

    protected _init(): void {
        super._init();

        this._templates = appUtils.tagsToStrMap(templates);

        this._inputName = document.body.querySelectorAll<HTMLElement>(".input-name, .input-name input");
        this._inputEmail = document.body.querySelectorAll<HTMLElement>(".input-email, .input-email input");
        this._inputTopic = document.body.querySelectorAll<HTMLElement>(".input-topic, .form-custom-select, .input-topic input");
        this._inputMessage = document.body.querySelectorAll<HTMLElement>(".input-message, .input-message textarea");
        // this._inputKVKK = document.body.querySelectorAll<HTMLElement>(".input-KVKK input, .input-KVKK .form-error");

        document.body.addEventListener('click', e => {
            const elm = e.target as HTMLElement;

            if (this._inputTopic[1].classList.contains('active')) {
                this._inputTopic[1].classList.remove('active');

                const elmValue = elm.dataset.value != undefined ? elm : (elm.parentElement.dataset.value != undefined ? elm.parentElement : null)
                if (elmValue) {
                    (this._inputTopic[2] as HTMLInputElement).value = this._inputTopic[1]
                        .querySelector(`li:nth-child(${parseInt(elmValue.dataset.value) + 1})>span[lang='${this._langs.currentId}']`)
                        .textContent;
                }
            }
            else if (elm == this._inputTopic[1])
                this._inputTopic[1].classList.add('active');
        });

        document.body.querySelector<HTMLButtonElement>(".btn-send")
            .addEventListener("click", () => this._checkAndSend());

        this._dotsCont = document.body.querySelector(".map-wrap");
        this._populateItems();
    }

    private _populateItems() {
        this._dots = [];
        mapPlaces.forEach(item => {
            let elm = appUtils.stringToHTML(this._templates["map-item"]
                .replace("{headOffice}", item.headOffice ? 'yes' : 'no')
            );
            elm.style.left = item.x / configs.defMapWidth * 100 + "%";
            elm.style.top = item.y / configs.defMapHeight * 100 + "%";
            this._dots.push(elm);
            this._dotsCont.append(elm);
        });
    }

    private async _checkAndSend() {
        this._inputName[0].classList.remove("form-invalid")
        this._inputEmail[0].classList.remove("form-invalid")
        this._inputTopic[0].classList.remove("form-invalid")
        this._inputMessage[0].classList.remove("form-invalid")

        const name = (this._inputName[1] as HTMLInputElement);
        if (!name.checkValidity()) {
            this._inputName[0].classList.add("form-invalid")
            return;
        }
        const email = (this._inputEmail[1] as HTMLInputElement);
        if (!email.checkValidity()) {
            this._inputEmail[0].classList.add("form-invalid")
            return;
        }
        const topic = (this._inputTopic[2] as HTMLInputElement);
        if (topic.value.length < 2) {
            this._inputTopic[0].classList.add("form-invalid")
            return;
        }
        const message = (this._inputMessage[1] as HTMLTextAreaElement);
        if (!message.checkValidity()) {
            this._inputMessage[0].classList.add("form-invalid")
            return;
        }

        /* this._inputKVKK[1].style.display = "";
        if (!(this._inputKVKK[0] as HTMLInputElement).checkValidity()) {
            this._inputKVKK[1].style.display = "block";
            return;
        } */

        const showError = () => alert({
            en: "An error has occured. Please, try again later.", tr: "Bir hata oluştu. Lütfen, daha sonra tekrar deneyiniz.",
            ru: "Произошла ошибка. Пожалуйста, повторите попытку позже.", de: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut."
        }[this._langs.currentId])

        try {
            const response = await fetch('./service/', {
                method: 'post',
                headers: {
                    "Authorization": "Bearer 2d9f872c-82de-4051-8df9-02b47e6c61d4",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: new URLSearchParams({
                    "action_type": "contact",
                    "name": name.value,
                    "email": email.value,
                    "topic": topic.value,
                    "message": message.value,
                })
            });

            if (response.status == 200) {
                name.value = email.value = topic.value = message.value = "";
                alert({
                    en: "Form Saved. Thanks.", tr: "Form kaydedildi. Teşekkürler.",
                    ru: "Форма сохранена. Спасибо.", de: "Formular gespeichert. Vielen Dank."
                }[this._langs.currentId])
                console.log('Completed!', await response.text());
            } else
                showError();
        } catch (err) {
            console.error(`Error: ${err}`);
            showError();
        }
    }
}

export const app = new AppContact();